module.exports = __webpack_public_path__ + "img/kilian_landwehr_3.7c0a714f.jpg";